module.exports = __webpack_public_path__ + "img/home-phone-ic.29f06e14.png";